module.exports = __webpack_public_path__ + "static/media/time.d066f165.svg";